export default __webpack_public_path__ + "static/media/ic_delete_user.63fa2386.svg";